import { render, staticRenderFns } from "./appointmentRecord.vue?vue&type=template&id=321959bd&scoped=true"
import script from "./appointmentRecord.vue?vue&type=script&lang=js"
export * from "./appointmentRecord.vue?vue&type=script&lang=js"
import style0 from "./appointmentRecord.vue?vue&type=style&index=0&id=321959bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321959bd",
  null
  
)

export default component.exports